import { environment } from "../../../environments/environment";
import { ChartSelectionCard } from "../Interfaces/chart-selection-card";
import { AppConstants } from "./app-constants";

export class LineOrTrendChartConstants {
  lineOrTrendChartImgFolderPath: string = "../../../assets/Images/LineOrTrendChart/";
  /*baseUrl: string = environment.baseUrl;*/
  lineOrTrendChartModuleRoutePath = AppConstants.lineOrTrendCategoryPathMap.chartModuleRoutePath + "/";
  chartDescriptions: any = this.getChartDescriptions();
  lineOrTrendChartModuleComponentPath: string = AppConstants.lineOrTrendCategoryPathMap.moduleFolderPath;

  //contains the details of all kinds of line or trend charts that is available in th tool
  lineOrTrendChartTypes: ChartSelectionCard[] = [
    {
      "imgUrl": "",
      routePath: this.lineOrTrendChartModuleRoutePath + "Lineortrendchart1Custom",
      routePath2: "",
      description: [],
      chartFolderPath: this.lineOrTrendChartModuleComponentPath + "line-or-trend-chart1",
      chartFolderPath2: "",
      imgClassName: "lineChart01",
      chartTitle: "LINE CHART",
      chartId: 1,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Line chart"
    },
    // {
    //   "imgUrl": this.lineOrTrendChartImgFolderPath + "02linechart.png",
    //   routePath: this.lineOrTrendChartModuleRoutePath + "LineOrTrendChart2",
    //   routePath2: "",
    //   description: [],
    //   chartFolderPath: this.lineOrTrendChartModuleComponentPath + "line-or-trend-chart2",
    //   chartFolderPath2: "",
    //   imgClassName:"",
    //   chartTitle:"",
    //   chartId:2
    // },
    // {
    //   "imgUrl": this.lineOrTrendChartImgFolderPath + "03linechart.png",
    //   routePath: this.lineOrTrendChartModuleRoutePath + "LineOrTrendChart3",
    //   routePath2: "",
    //   description: [],
    //   chartFolderPath: this.lineOrTrendChartModuleComponentPath + "line-or-trend-chart3",
    //   chartFolderPath2: "",
    //   imgClassName:"",
    //   chartTitle:"",
    //   chartId:3
    // },
    // {
    //   "imgUrl": this.lineOrTrendChartImgFolderPath + "04linechart.png",
    //   routePath: this.lineOrTrendChartModuleRoutePath + "LineOrTrendChart4",
    //   routePath2: "",
    //   description: [],
    //   chartFolderPath: this.lineOrTrendChartModuleComponentPath + "line-or-trend-chart4",
    //   chartFolderPath2: "",
    //   imgClassName:"",
    //   chartTitle:"",
    //   chartId:4
    // },
    // {
    //   "imgUrl": this.lineOrTrendChartImgFolderPath + "05linechart.png",
    //   routePath: this.lineOrTrendChartModuleRoutePath + "LineOrTrendChart5",
    //   routePath2: "",
    //   description: [],
    //   chartFolderPath: this.lineOrTrendChartModuleComponentPath + "line-or-trend-chart5",
    //   chartFolderPath2: "",
    //   imgClassName:"",
    //   chartTitle:"",
    //   chartId:5
    // },
    // {
    //   "imgUrl": this.lineOrTrendChartImgFolderPath + "06linechart.png",
    //   routePath: this.lineOrTrendChartModuleRoutePath + "LineOrTrendChart6",
    //   routePath2: "",
    //   description: [],
    //   chartFolderPath: this.lineOrTrendChartModuleComponentPath + "line-or-trend-chart6",
    //   chartFolderPath2: "",
    //   imgClassName:"",
    //   chartTitle:"",
    //   chartId:6
    // }
  ]

  //Returns the descriptions that has to be displayed in customization section of each line or trend chart
  getChartDescriptions() {
    let chartDescription = {
      lineOrTrendChart1: [
        "Area colour: solid single colour, solid multicolour,\
            linear gradient colour(two variation colour).",
        "X-Axis: Text, image and both (text/image) can be added.",
        "X-axis text can be single colour or solid multicolour.",
        "Y-axis label line can be dotted or solid line.",
        "Markers in plot options in series can be enabled or can be disabled.",
        "Grid lines on both axis can be styled."
      ],
      lineOrTrendChart2: [
        "PlotBands colour: solid single colour, solid multicolour, \
          linear gradient colour (two variation colour).",
        "X-Axis: Text, image and both (text/image) can be added.",
        "X-axis text can be single colour or solid multicolour.",
        "Y-axis label line can be disabled or enabled.",
        "Markers in plot options in series can be enabled or can be disabled \
          and Markers shape can be circle,square,diamond,triangle or any image."
      ],
      genericLineOrTrendChartDescription: [
        "X-Axis: Text, image and both (text/image) can be added.",
        "X-axis text can be single colour or solid multicolour.",
        "Y-axis label line can be disabled or enabled.",
        "Markers in plot options in series can be enabled or can be disabled \
          and Markers shape can be circle,square,diamond,triangle or any image."
      ]
    }
    return chartDescription;
  }
}
